import { apiClient } from "@/lib/api/http"

export async function forgotPassword(email: string): Promise<void> {
  await apiClient.post("/auth/forgot-password", { email })
}

export async function resetPassword(payload: {
  email: string
  otp: string
  newPassword: string
}): Promise<void> {
  await apiClient.post("/auth/reset-password", payload)
}
